import { Formik } from "formik";
import {useCallback, useMemo, useState} from "react";
import { Form, Button, Typography, Input, Upload } from "antd";

import {FormItem, RadioGroup, SelectSearch} from "components";
import {ADD_ISSUE_FORMIK, BATTERY_FIRMWARE, ORGANIZATION_FIRMWARE} from "utils/formik-data";
import {BatteryValues, OrganizationValues} from "types/formik";
import { SelectType } from "types";
import {addBattery, addOrganization, setModalName, updateOrganization} from "store/actions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";
import organizations from "../../store/reducers/clients-reducer";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";

const { Title, Text } = Typography;

export default function EditOrganizationForm() {
    const{
        organizations: {selectedOrganization},
        common: { userType =1 },
    } = useSelector<AppState, AppState>((state) => state);
    const clinetType = [{label: "B2B", value: 1},{label: "B2C", value: 2}]
    const [business, setBusiness] = useState(1);
    const dispatch = useDispatch();
    const orgType = [
        {
            label: "Fleet Owner",
            value: "FLEET_OWNER"
        },
        {
            label: "Fleet Client",
            value: "FLEET_CLIENT"
        },
    ];
    var filerOrg = orgType.filter(or => {
        console.log("userType : ", userType,  userType != 1);
        if (userType != 1) {
            return or.value != "FLEET_OWNER"
        }
        return or

    })
    const initialValues = useMemo(() => {
        return {
            name: selectedOrganization?.name || "",
            street_address: selectedOrganization?.address?.streetAddress1 || "",
            city: selectedOrganization?.address?.city || "",
            state: selectedOrganization?.address?.state || "",
            country: selectedOrganization?.address?.country || "",
            org_type: selectedOrganization?.orgType || "",
            business_type: selectedOrganization?.businessType || 1,
            national_id: selectedOrganization?.clientUserItem?.cnic || "",
            email: selectedOrganization?.clientUserItem?.email,
            phone_number: selectedOrganization?.clientUserItem?.phone,
            dial_code: "",
        }
    }, [selectedOrganization]);


    const onCancels = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);

    const onSubmit = useCallback(
        (values: OrganizationValues) => {
            console.log("organization Values : ", values)
            dispatch(
                updateOrganization({
                    id: selectedOrganization?.id || "",
                    name: values.name || "",
                    street_address: values.street_address,
                    city: values.city || "",
                    state: values.state || "",
                    country: values.country || "",
                    org_type: values.org_type || "",
                    national_id: values.national_id || "",
                    email: values.email || "",
                    phone_number: values.phone_number || "",
                    business_type: selectedOrganization?.businessType
                })
            );
            onCancels();
        },
        [dispatch, onCancels, selectedOrganization?.id]
    );

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ORGANIZATION_FIRMWARE.validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({
                  setFieldValue,
                  dirty,
                  isValid,
                  handleSubmit,
                  handleChange,
                  values,
                  errors,
              }) => (
                <div className="form-container">
                    <Title level={5}>Update Client</Title>
                    <Text className="description" type="secondary">
                    Please provide the following details to update client details
                    </Text>
                    <Form className="--add-vehicles-form" onFinish={handleSubmit}>
                       <div className="form-fields-section">
                             <div className="form-field-wrapper">
                            <FormItem
                                verticalAlign="flex-start"
                                error={errors.business_type}
                                label="Type"
                                required
                            >
                                <RadioGroup
                                    options={clinetType}
                                    value={values.business_type || 1}
                                    onChange={(selected) => {
                                        setFieldValue("business_type", selected.target.value);setBusiness(selected.target.value);
                                    }}
                                    disabled={true}
                                />
                            </FormItem>
                            </div>
                             <div className="form-field-wrapper">
                            <FormItem label="Name" error={errors.name} required>
                                <Input
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    disabled={userType == 1 || userType == 2 ? false : true}
                                />
                            </FormItem>
                            </div>
                                <div className="form-field-wrapper">
                            <FormItem label="Street Address" error={errors.street_address} required>
                                <Input
                                    name="street_address"
                                    value={values.street_address}
                                    onChange={handleChange}
                                    placeholder="Street Address"
                                />
                            </FormItem>
                            </div>
                                <div className="form-field-wrapper">
                            <FormItem label="City" error={errors.city} required>
                                <Input
                                    name="city"
                                    value={values.city}
                                    onChange={handleChange}
                                    placeholder="City"
                                />
                            </FormItem>
                            </div>
                                <div className="form-field-wrapper">
                            <FormItem label="Province" error={errors.state} required>
                                <Input
                                    name="state"
                                    value={values.state}
                                    onChange={handleChange}
                                    placeholder="Province"
                                />
                            </FormItem>
                            </div>
                                <div className="form-field-wrapper">
                            <FormItem label="Country" error={errors.country} required>
                                <Input
                                    name="country"
                                    value={values.country}
                                    onChange={handleChange}
                                    placeholder="Country"
                                />
                            </FormItem>
                            </div>
                             <div className="form-field-wrapper">
                            {/*<FormItem label="Organization Type" error={errors.org_type} required>*/}
                            {/*    <SelectSearch*/}
                            {/*        isMultiple={false}*/}
                            {/*        value={values.org_type || ""}*/}
                            {/*        items={filerOrg}*/}
                            {/*        setFieldValue={setFieldValue}*/}
                            {/*        fieldName="org_type"*/}
                            {/*        placeholder="Select"*/}
                            {/*        onChangeProp={(value) => {*/}
                            {/*            setFieldValue("org_type", value);*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*</FormItem>*/}
                                 {selectedOrganization?.businessType == 1 &&
                                     <div className="form-field-wrapper">
                                         <FormItem label="Organization Type" error={errors.org_type} required>
                                             <SelectSearch
                                                 isMultiple={false}
                                                 value={values.org_type || ""}
                                                 items={filerOrg}
                                                 setFieldValue={setFieldValue}
                                                 fieldName="org_type"
                                                 placeholder="Select"
                                                 onChangeProp={(value) => {
                                                     setFieldValue("org_type", value);
                                                 }}
                                             />
                                         </FormItem>
                                     </div>
                                 }
                                 {selectedOrganization?.businessType == 2 &&
                                     <>
                                         <div className="form-field-wrapper">
                                             <FormItem label="Email" error={errors.email} required>
                                                 <Input
                                                     name="email"
                                                     value={values.email}
                                                     onChange={handleChange}
                                                     placeholder="Email"
                                                 />
                                             </FormItem>
                                         </div>
                                         <div className="form-field-wrapper">
                                             <FormItem label="National ID" error={errors.national_id} required>
                                                 <Input
                                                     name="national_id"
                                                     value={values.national_id}
                                                     onChange={handleChange}
                                                     placeholder="National ID"
                                                     disabled={userType == 1 || userType == 2 ? false : true}
                                                 />
                                             </FormItem>
                                         </div>
                                         {/*<FormItem label="Phone Number" error={errors.phone_number} required>*/}
                                         {/*    <Input*/}
                                         {/*        name="phone_number"*/}
                                         {/*        value={values.phone_number}*/}
                                         {/*        onChange={handleChange}*/}
                                         {/*        placeholder="Phone Number"*/}
                                         {/*    />*/}
                                         {/*</FormItem>*/}
                                         <div className="form-field-wrapper">
                                             <FormItem label="Phone Number" error={errors.phone_number} required>
                                                 <PhoneInput
                                                     country="pk"
                                                     inputProps={{
                                                         required: true,
                                                         autoFocus: true,
                                                         name: "phone_no",
                                                     }}
                                                     inputClass="login-phone-input --user"
                                                     buttonClass="user-flag"
                                                     placeholder="12345678"
                                                     value={values.phone_number}
                                                     onChange={(val, data: { dialCode: string }) => {
                                                         setFieldValue("dial_code", data.dialCode);
                                                         setFieldValue("phone_number", val);
                                                     }}
                                                 />
                                             </FormItem>
                                         </div>
                                     </>
                                 }
                            </div>
                        </div>
                        <div className="action-btn-container">
                            <>
                                <Button className="cancel-btn" onClick={onCancels}>
                                    Cancel
                                </Button>
                                <Button
                                    htmlType="submit"
                                    type="primary"
                                    disabled={(!isValid && dirty)}
                                >
                                    Save
                                </Button>
                            </>
                        </div>
                    </Form>
                </div>
            )}
        </Formik>
    );
}